import { useContext } from 'react';
import DisabledContext from '../DisabledContext';
import SizeContext from '../SizeContext';

function useConfig() {
  var componentDisabled = useContext(DisabledContext);
  var componentSize = useContext(SizeContext);
  return {
    componentDisabled: componentDisabled,
    componentSize: componentSize
  };
}

export default useConfig;